import { Component } from '@angular/core';
import {ProjectsService} from "../../../services/projects.service";
import {CoreService} from "../../../services/core.service";
import {environment} from "../../../../../environments/environment";

@Component({
  selector: 'app-thank-you-contract',
  templateUrl: './thank-you-contract.component.html',
  styleUrls: ['./thank-you-contract.component.sass']
})
export class ThankYouContractComponent {
  constructor(
    private coreService: CoreService
  ) {
    this.coreService.enableThankYouPage();
  }
}
